import { Image, Radio, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

function SharingType({
  setPrimaryButtonDisabled,
  setPrimaryButtonText,
  setSelectedShareType,
  selectedShareType
}) {
  const { t } = useTranslation();

  const emailInputLabel = (
    <>
      <Typography variant="body2Bold">{t('sendRecipientsViaEmail')}</Typography>
      <Typography variant="body2" color="neutral" emphasis="500">
        ({t('automatedEmailSentByMerchant')})
      </Typography>
    </>
  );

  const createLinkInputLabel = (
    <>
      <Typography variant="body2Bold">{t('createGiftLink')}</Typography>
      <Typography variant="body2" color="neutral" emphasis="500">
        ({t('createGiftLinkDesc')})
      </Typography>
    </>
  );

  return (
    <S.ShareTypeWrapper>
      <S.SelectionContent>
        <Typography variant="body1Bold">{t('howWouldYouLikeToShare')}</Typography>
        <Radio
          value="email"
          checked={selectedShareType === 'email'}
          onChange={() => {
            setSelectedShareType('email');
            setPrimaryButtonDisabled(false);
            setPrimaryButtonText(t('next'));
          }}
          label={emailInputLabel}
        />
        <Radio
          value="create-link"
          checked={selectedShareType === 'create-link'}
          onChange={() => {
            setSelectedShareType('create-link');
            setPrimaryButtonDisabled(false);
            setPrimaryButtonText(t('okay'));
          }}
          label={createLinkInputLabel}
        />
      </S.SelectionContent>
      <Image name="orderConfirmed" />
    </S.ShareTypeWrapper>
  );
}

export default SharingType;
